import { render, staticRenderFns } from "./AreaEventHistory.vue?vue&type=template&id=2db70f1a&scoped=true"
import script from "./AreaEventHistory.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistory.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistory.vue?vue&type=style&index=0&id=2db70f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db70f1a",
  null
  
)

export default component.exports